module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Navi-Hype-Reel-Video.fd8b9aa3.jpg";